import React, { useState, useEffect } from "react";
import classes from "./Calendar.module.css";
import EventFilters from "../../components/Filters/Filters";
import banner from "../../assets/banner.svg";
import Card from "../../components/Card/Card";
import { Paginator } from "primereact/paginator";
import localeData from "../../assets/locale/locale.json";
import { locale, addLocale } from "primereact/api";
import logo01 from "../../assets/logo01.svg";
import logo02 from "../../assets/logo02.svg";
import logo03 from "../../assets/logo03.svg";
import logo04 from "../../assets/logo04.svg";
import logo05 from "../../assets/logo05.svg";

addLocale("ru", localeData.ru);
locale("ru");

function CalendarPage() {
  const [eventsData, setEventsData] = useState([]);
  const [filteredEvents, setFilteredEvents] = useState([]);
  const [resultsAvailableCount, setResultsAvailableCount] = useState(0);
  const [applicationAvailableCount, setApplicationAvailableCount] = useState(0);
  const [first, setFirst] = useState(0);
  const [rows, setRows] = useState(12);

  useEffect(() => {
    const fetchData = async () => {
      const response = await fetch(
        "https://7fe54de6-ee3a-477e-8e1c-10137a45514e.selstorage.ru/amurskaya.json"
      );
      const data = await response.json();
      setEventsData(data);
      setFilteredEvents(data);
      updateCounts(data);
    };
    fetchData();
  }, []);

  const updateCounts = (data) => {
    const countResults = data.filter(
      (event) => event.event_results?.toLowerCase() === "да"
    ).length;
    const countApplications = data.filter(
      (event) => event.event_application?.toLowerCase() === "да"
    ).length;

    setResultsAvailableCount(countResults);
    setApplicationAvailableCount(countApplications);
  };

  const onPaginationChange = (event) => {
    setFirst(event.first);
    setRows(event.rows);
  };

  const filterEvents = (filters) => {
    const filtered = eventsData.filter((event) => {
      return (
        (!filters.sport_type || event.sport_type === filters.sport_type) &&
        (!filters.event_type || event.event_type === filters.event_type) &&
        (!filters.event_status ||
          event.event_status === filters.event_status) &&
        (!filters.age || event.age === filters.age) && // Пример фильтрации по возрасту
        (!filters.event_region ||
          event.event_region === filters.event_region) &&
        (!filters.start_date || isDateInRange(event, filters.start_date)) &&
        (!filters.event_application ||
          event.event_application?.toLowerCase() === "да") &&
        (!filters.event_results || event.event_results?.toLowerCase() === "да")
      );
    });

    setFilteredEvents(filtered);
    updateCounts(filtered); // Обновляем счетчики после фильтрации
  };

  const isDateInRange = (event, filterDate) => {
    const startDate = new Date(event.start_date);
    const endDate = new Date(event.end_date);
    const filter = new Date(filterDate);
    return filter >= startDate && filter <= endDate;
  };

  return (
    <div className={classes.Calendar}>
      <div className={classes.CalendarLogoWrapper}>
        <a href="https://moisport.ru/" target="_blank">
          <img src={logo01}></img>
        </a>
        <a href="https://norma-sport.ru/" target="_blank">
          <img src={logo02}></img>
        </a>
        <a href="https://minsport.amurobl.ru/" target="_blank">
          <img src={logo03}></img>
        </a>
        <a href="https://www.minsport.gov.ru/" target="_blank">
          <img src={logo04}></img>
        </a>
        <a href="https://www.gto.ru/" target="_blank">
          <img src={logo05}></img>
        </a>
      </div>
      <EventFilters
        onFilterChange={filterEvents}
        events={eventsData}
        resultsAvailableCount={resultsAvailableCount}
        applicationAvailableCount={applicationAvailableCount}
      />
      <div className={classes.CardWrapper}>
        {filteredEvents.slice(first, first + rows).map((event, index) => (
          <Card
            key={`${event.id}-${index}`} // Adding index to ensure uniqueness
            id={event.id}
            mainImg={event.mainImg}
            time={event.start_date}
            location={event.event_region}
            title={event.event_name}
            description={event.additional_info}
            startDate={event.start_date}
            endDate={event.end_date}
            sportType={event.sport_type}
            eventType={event.event_type}
            eventStatus={event.event_status}
            eventOrg={event.event_org}
            eventAddress={event.event_address}
            eventPartDeadline={event.event_part_deadline}
            eventOrgHead={event.event_org_head}
            reqDocuments={event.req_documents}
            provisions={event.url}
            event_results={event.event_results}
            event_application={event.event_application}
          />
        ))}
      </div>
      <Paginator
        first={first}
        rows={rows}
        totalRecords={filteredEvents.length}
        onPageChange={onPaginationChange}
        rowsPerPageOptions={[6, 12, 24]}
      />
      <p className={classes.footer}>
        © 2021 - {new Date().getFullYear()} АО «Мой спорт» <br />
        Все права защищены.
        <br /> При использовании материалов в любых целях, ссылка на
        первоисточник обязательна.
      </p>
    </div>
  );
}

export default CalendarPage;
